export default "/images/vendor/flag-icons/flags/4x3/cw.svg?7b83329130ff6a4d69d47c376dbebc79";